export const LOCAL_STORAGE_KEY = {
  HOME_EVENT_POPUP_DATE: 'HOME_EVENT_POPUP_DATE'
} as const;
